(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vt-instknop"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const link = e.target.closest('.vt-instknop__cta[data-vt-paal]');
    if (!link) return;
    const veld = document.querySelector('.vt-buy form[action*="/cart/add"] [name="id"]')
      || document.querySelector('form[action*="/cart/add"] [name="id"]');
    const id = (veld && veld.value) || new URL(location.href).searchParams.get('variant');
    if (!id) return;
    const doel = new URL(link.getAttribute('href'), location.origin);
    doel.searchParams.set('variant', id);
    link.setAttribute('href', doel.pathname + doel.search);
  });
  } catch(e) { console.error(e); }
})();

})();
